import { combineReducers } from "redux";
import paramsReducer from "./paramsReducer";
import accountReducer from "./accountReducer";
import productsReducer from "./accountReducer";

export default combineReducers({ paramsReducer, accountReducer, productsReducer });
